import { useInputState } from './useInputState';

const validations = [
  {
    validate: (value) => value && value.trim && !!value.trim(),
    errorMessage: 'dateOfBirth.yearError'
  },
  {
    validate: (value) => new Date().getFullYear() <= Number(value),
    errorMessage: 'dateOfBirth.yearError'
  }
];

export function useYearInputState(options) {
  return useInputState({
    initialValue: null,
    validations,
    ...(options || {})
  });
}
